export default "__VITE_ASSET__b3ddad2e__"